import initialState, { IProgressState } from '../modules/progress/IProgressSate';
import { CALCULATION_PROGRESS_RECEIVED, IMPORT_DATA_PROGRESS_RECEIVED, CLEAR_CALCULATION_PROGRESS_STATE, 
    CLEAR_IMPORT_PROGRESS_STATE, CANCELED_IMPORT_PROGRESS_STATE, IMPORT_INSTRUMENTS_PROGRESS_RECEIVED, CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE, CANCELED_IMPORT_INSTRUMENTS_PROGRESS_STATE } from '../modules/progress/progress.action.const';
import { calculationProgressReceived, importDataProgressReceived, clearCalculationProgress, clearImportDataProgress, cancelImportDataProgress, importInstrumentsProgressReceived, clearImportInstrumentsProgress, cancelImportInstrumentsProgress } from '../modules/progress/progress.reducer.logic';

export function progressReducer(state: IProgressState = initialState, action) {
    switch (action.type) {
        case CALCULATION_PROGRESS_RECEIVED:
            return calculationProgressReceived(state, action);
        case CLEAR_CALCULATION_PROGRESS_STATE:
            return clearCalculationProgress(state, action);

        case IMPORT_DATA_PROGRESS_RECEIVED:
            return importDataProgressReceived(state, action);
        case CLEAR_IMPORT_PROGRESS_STATE:
            return clearImportDataProgress(state, action);
        case CANCELED_IMPORT_PROGRESS_STATE:
            return cancelImportDataProgress(state, action);

        case IMPORT_INSTRUMENTS_PROGRESS_RECEIVED:
            return importInstrumentsProgressReceived(state, action);
        case CLEAR_IMPORT_INSTRUMENTS_PROGRESS_STATE:
            return clearImportInstrumentsProgress(state, action);
        case CANCELED_IMPORT_INSTRUMENTS_PROGRESS_STATE:
            return cancelImportInstrumentsProgress(state, action);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/app-states/reducers/progress.reducer.ts